import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { ContextService } from '../../services/context.service';
import { StatsService } from '../../services/stats.service';
import { IEvent, MatchStatus } from '../../services/match.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-scoreboard',
  templateUrl: './scoreboard.component.html',
  styleUrls: ['./scoreboard.component.scss']
})
export class ScoreboardComponent implements OnInit, OnDestroy {
  _events: IEvent[] = [];
  _match: any = {};
  @Input() get match(): any { return this._match; }
           set match(match: any) {
            this._match = match;
            this.refreshResults();
           }
  @Input() get events(): IEvent[] { return this._events; }
           set events(events: IEvent[]) {
              this._events = events;
              this.refreshResults();
           }
  @Input() live = false;

  @ViewChild('bigHeader', { static: false }) bigHeader: ElementRef;
  @ViewChild('smallHeader', { static: false }) smallHeader: ElementRef;

  fullScore = {
    home: 0,
    visitor: 0,
    diff: 0
  };
  score: any;
  quarter = MatchStatus.Finished;
  headerScrollActive = false;
  scrollCallback: any;
  header: boolean;

  private contextSubscription: Subscription;

  constructor(
    private statsService: StatsService,
    public context: ContextService,
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {
    this.score = {
      home: 0,
      visitor: 0,
      quarter: this.translateService.instant('Full time')
    };
    this.header = false
  }

  ngOnInit() {
    this.scrollCallback = this.onScroll.bind(this);
    this.contextSubscription = this.context.contextChanged$.subscribe((context) => {
      if (context.quarter < 10) {
        switch (context.quarter) {
          case MatchStatus.NotStarted: this.score.quarter = this.translateService.instant('Not started');
                  break;
          case MatchStatus.Quarter1: this.score.quarter = this.translateService.instant('1st quarter');
                  break;
          case MatchStatus.Quarter2: this.score.quarter = this.translateService.instant('2nd quarter');
                  break;
          case MatchStatus.Quarter3: this.score.quarter = this.translateService.instant('3rd quarter');
                  break;
          case MatchStatus.Quarter4: this.score.quarter = this.translateService.instant('4th quarter');
                  break;
          case MatchStatus.Break : this.score.quarter = this.translateService.instant('Break');
                  break;
          case MatchStatus.Finished: this.score.quarter = this.translateService.instant('Full time');
                  break;
        }
      } else {
        if (context.quarter === MatchStatus.Cancelled) {
          this.score.quarter = this.translateService.instant('Cancelled');
        } else {
          const overtimeText = this.translateService.instant('overtime');
          const overtimeNum = context.quarter - 9;
          this.score.quarter = `${overtimeText} ${overtimeNum}`;
        }
      }
      this.refreshResults();
      this.quarter = context.quarter;
      this.live = context.live;
    });

    this.route.queryParams
    .subscribe(params => {
      console.log(params); // { orderby: "price" }
      if (params.header) {
        this.header = params.header === 'true' ? true : false
      }
    })
    this.refreshResults();
    window.addEventListener('scroll', this.scrollCallback);
  }

  ngOnDestroy () {
    if (this.contextSubscription) { this.contextSubscription.unsubscribe(); }
    window.removeEventListener('scroll', this.scrollCallback);
  }

  onScroll() {
    const bigHeaderHeight = this.bigHeader.nativeElement.scrollHeight;
    const bigHeaderTop = bigHeaderHeight + this.bigHeader.nativeElement.offsetTop;
    const smallHeaderHeight = this.smallHeader.nativeElement.scrollHeight;
    const currentScroll = document.body.scrollTop || document.documentElement.scrollTop;
    this.headerScrollActive = currentScroll > (bigHeaderTop - smallHeaderHeight);
  }

  private refreshResults () {
    if (this.events.length && this.match.home) {
      const quarter = this.context.getQuarter();
      // Calculate result
      const fullResult = this.statsService.calculateResult(this.events, this.match, quarter, true);
      const quarterResult = this.statsService.calculateResult(this.events, this.match, quarter, false);
      this.fullScore.home = fullResult.home;
      this.fullScore.visitor = fullResult.visitor;
      this.fullScore.diff = fullResult.home - fullResult.visitor;
      this.score.home = quarterResult.home;
      this.score.visitor = quarterResult.visitor;
      this.score.diff = fullResult.home - fullResult.visitor;
      // TODO: Set right timming
      this.score.time = this._events[this._events.length - 1].time;
    }
  }

  hasStarted() {
    const date = Date.parse(this.match.date);
    return (date && (Date.now() > date));
  }

  getStageLabel(stage) {
    let label;
    switch (stage) {
      case 0: label = this.translateService.instant('Matchday');
              break;
      case 1: label = this.translateService.instant('Final');
              break;
      case 2: label = this.translateService.instant('Semi final');
              break;
      case 3: label = this.translateService.instant('Quarter final');
              break;
      case 4: label = this.translateService.instant('Round of 16');
              break;
      case 5: label = this.translateService.instant('6th round');
              break;
      case 6: label = this.translateService.instant('5th round');
              break;
      case 7: label = this.translateService.instant('4th round');
              break;
      case 8: label = this.translateService.instant('3rd round');
              break;
      case 9: label = this.translateService.instant('2nd round');
              break;
      case 10: label = this.translateService.instant('1st round');
              break;
      default: label = this.translateService.instant('Game');
              break;
    }
    return label;
  }

}
